var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { batch } from "react-redux";
import { TrackJS } from "trackjs";
import { registerCard } from "interfaces/order";
import { findCardTypeByFirstDigit } from "helpers/credit_cards";
import uuid from "uuid/v4";
import { getDigitalGiftCardsSettings, postCreditCardPayment, } from "interfaces/digital_gift_cards";
import { RequestStatus } from "types/requests";
import { head, takeLast } from "ramda";
import { generateConfirmationCode, transformOrderInfo, } from "helpers/transforms/digital_gift_cards";
export var SET_DIGITAL_GIFT_CARDS_SETTINGS = "digital_gift_cards/SET_DIGITAL_GIFT_CARDS_SETTINGS";
export var SET_PROCESSED_GIFT_CARD_PAYMENT = "digital_gift_cards/SET_PROCESSED_GIFT_CARD_PAYMENT";
export var SET_CREDIT_CARD_REQUEST_STATUS = "digital_gift_cards/SET_CREDIT_CARD_REQUEST_STATUS";
function setDigitalGiftCardsSettingsRequestStatus(settings) {
    return {
        type: SET_DIGITAL_GIFT_CARDS_SETTINGS,
        settings: settings,
    };
}
function setProcessedGiftCardPaymentRequestStatus(processedGiftCardPayment) {
    return {
        type: SET_PROCESSED_GIFT_CARD_PAYMENT,
        processedGiftCardPayment: processedGiftCardPayment,
    };
}
export function setCreditCardRequestStatus(status) {
    return {
        type: SET_CREDIT_CARD_REQUEST_STATUS,
        status: status,
    };
}
export function getAndUpdateDigitalGiftCardsSettings() {
    return function (dispatch) {
        dispatch(setDigitalGiftCardsSettingsRequestStatus({
            type: RequestStatus.REQUESTING,
        }));
        getDigitalGiftCardsSettings()
            .then(function (settings) {
            dispatch(setDigitalGiftCardsSettingsRequestStatus({
                type: RequestStatus.SUCCESS,
                result: settings,
            }));
        })
            .catch(function (error) {
            dispatch(setDigitalGiftCardsSettingsRequestStatus({
                type: RequestStatus.FAILURE,
                reason: "error fetching settings from S3",
            }));
            // if we aren't getting settings back they either
            // don't exist or AWS is down
            TrackJS.track("error fetching settings from S3: " + error);
        });
    };
}
function catchCardRegistrationError(error) {
    return function (dispatch) {
        dispatch(setCreditCardRequestStatus(RequestStatus.FAILURE));
        TrackJS.track("error registering credit card: " + error);
    };
}
function catchPaymentError(error) {
    return function (dispatch) {
        batch(function () {
            // Attempt to get a more specific error message from the repsonse body
            error.response
                .json()
                .then(function (resp) {
                var _a, _b, _c;
                dispatch(setProcessedGiftCardPaymentRequestStatus({
                    type: RequestStatus.FAILURE,
                    reason: (_c = (_b = (_a = resp.error) !== null && _a !== void 0 ? _a : resp.message) !== null && _b !== void 0 ? _b : error.message) !== null && _c !== void 0 ? _c : "There was an error processing your request. Please check the form and try again.",
                }));
            })
                .catch(function () {
                dispatch(setProcessedGiftCardPaymentRequestStatus({
                    type: RequestStatus.FAILURE,
                    reason: "There was an error processing your request. Please check the form and try again.",
                }));
            })
                .finally(function () {
                return dispatch(setCreditCardRequestStatus(RequestStatus.FAILURE));
            });
        });
        TrackJS.track("error submitting order: " + error);
    };
}
export function submitCreditCardPayment(_a) {
    var total = _a.total, paymentMethodToken = _a.paymentMethodToken, cardInfo = _a.cardInfo, formInfo = _a.formInfo, storePrettyUrl = _a.storePrettyUrl, sessionId = _a.sessionId;
    var cardForRegistry = {
        firstName: cardInfo.firstName,
        lastName: cardInfo.lastName,
        paymentMethodToken: paymentMethodToken,
        lastFour: takeLast(4, cardInfo.cardNumber),
        nameOnCard: cardInfo.firstName + " " + cardInfo.lastName,
        line1: cardInfo.address1,
        line2: cardInfo.address2,
        city: cardInfo.city,
        state: cardInfo.state,
        zip: cardInfo.zip,
        cardType: findCardTypeByFirstDigit(head(cardInfo.cardNumber)).prettyName.toLowerCase(),
        storePrettyUrl: storePrettyUrl,
    };
    return function (dispatch) {
        registerCard(cardForRegistry)
            .then(function (_a) {
            var consumerId = _a.consumerId, cardId = _a.cardId;
            var submitDate = new Date();
            var paymentRequestInfo = {
                sessionId: sessionId,
                storePrettyUrl: storePrettyUrl,
                confirmationCode: generateConfirmationCode(storePrettyUrl),
                timePlaced: submitDate.toISOString(),
                submissionId: uuid(),
                cardUuid: cardId,
                consumerUuid: consumerId,
                consumerFirstName: cardInfo.firstName,
                consumerLastName: cardInfo.lastName,
                cvv: cardInfo.cvv,
                consumerPhoneNumber: formInfo.senderPhone.replace(/\D/g, ""),
                consumerEmail: formInfo.senderEmail,
                orderTotal: total.valueOf(),
                digitalGiftCards: [transformOrderInfo(formInfo)],
            };
            dispatch(setProcessedGiftCardPaymentRequestStatus({
                type: RequestStatus.REQUESTING,
            }));
            postCreditCardPayment(paymentRequestInfo)
                .then(function (processedPaymentInfo) {
                batch(function () {
                    dispatch(setProcessedGiftCardPaymentRequestStatus({
                        type: RequestStatus.SUCCESS,
                        result: __assign(__assign({}, processedPaymentInfo), { lastFour: takeLast(4, cardInfo.cardNumber) }),
                    }));
                    dispatch(setCreditCardRequestStatus(RequestStatus.SUCCESS));
                });
            })
                .catch(function (error) {
                dispatch(catchPaymentError(error));
            });
        })
            .catch(function (error) {
            dispatch(catchCardRegistrationError(error));
        });
    };
}
